export const enum SuggestionType {
  Cheapest = 'cheapest',
  MostPopular = 'mostPopular',
}
